import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer>
      <div className="d-lg-flex text-center justify-content-between bg-black fs-6" id="footer">
        <p className="mr265">
          Follow us on
          <a className="ml60 mr20" href="https://www.instagram.com/whatsnxtapp/" target="_blank" rel="noopener noreferrer">
            <img src="/assets/images/social/instagram.png" alt="instagram" />
          </a>
          <a className="mr20" href="https://www.linkedin.com/company/whatsnxt-global/" target="_blank" rel="noopener noreferrer">
            <img src="/assets/images/social/linkedin.png" alt="linkedin" />
          </a>
          <a href="https://www.tiktok.com/@whatsnxtapp" target="_blank" rel="noopener noreferrer">
            <img src="/assets/images/social/tiktok.png" alt="tiktok" />
          </a>
        </p>
        <p className="mr265">
          <a href="https://whatsnxt.app/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy</a> |{' '}
          <a href="https://whatsnxt.app/terms-of-service/" target="_blank" rel="noopener noreferrer">Terms of service</a>
        </p>
            <p>&copy; Whatsnxt2024</p>
      </div>
    </footer>
  );
};

export default Footer;
